import { useStore } from 'react-redux';
import { fetchWishlistMembership } from '../services/wishlist/wishlist-membership-query';
import isFavoriteKnownFromList from '../utils/material/is-favorite-known-from-list';
import isInFavorites from '../utils/material/is-in-favorites';
import session from '../utils/session';

type CheckIsInFavorites = (materialId: number) => Promise<boolean>;

// Answers "is this material a favorite?" only when called (e.g. after a click), so rendering a button makes no
// request. Reads the store at call time; a failed check answers false, so nothing is removed by mistake.
const useCheckIsInFavorites = (): CheckIsInFavorites => {
    const store = useStore<RootState>();

    return (materialId) => {
        const { favorite } = store.getState().main;

        if (isFavoriteKnownFromList(materialId, favorite)) {
            return Promise.resolve(isInFavorites(materialId, favorite));
        }

        return fetchWishlistMembership(session.isLoggedIn(), materialId).catch(() => false);
    };
};

export default useCheckIsInFavorites;
